export const getParentCategory = (text: string) =>
  (text || '').split(':').slice(0, -1).join(':') || '';

export default getParentCategory;
